export const ComplianceRoutes = { path: 'compliance/*', lazy: () => import('../pages/compliance') };
